import { createLogger } from "logging";
import { useDocumentsPanel } from "providers";
import { useTranslations } from "providers";

import { ExistingDocument } from "./ExistingDocument";

const logger = createLogger("DocumentsPanel.ExistingDocuments");

export const ExistingDocuments = () => {
  const i18n = useTranslations();

  const { agendaItem } = useDocumentsPanel();
  if (!agendaItem) {
    return null;
  }

  let { workingDocuments = [] } = agendaItem;
  workingDocuments = [...workingDocuments].sort((a, b) => a.fileName.localeCompare(b.fileName));
  logger.debug(`render(): agendaItem:=${agendaItem}, documents:=`, workingDocuments);

  return (
    <>
      <div className="description">{i18n.DocumentsPanel_Description}:</div>
      <table className="table sbb-table-bs table-hover">
        <thead>
          <tr>
            <th>{i18n.WorkingDocument_FileName}</th>
            <th>{i18n.Modified}</th>
            <th>{i18n.ModifiedBy}</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {!workingDocuments.length && (
            <tr>
              <td colSpan={2}>{i18n.DocumentsForm_None}</td>
            </tr>
          )}
          {workingDocuments.length > 0 &&
            workingDocuments.map((document, index) => {
              const key = `doc-${index}`;
              return <ExistingDocument document={document} key={key} />;
            })}
        </tbody>
      </table>
    </>
  );
};
